import { render, staticRenderFns } from "./SelectRules.vue?vue&type=template&id=4ec0edf0&scoped=true"
import script from "./SelectRules.vue?vue&type=script&lang=ts"
export * from "./SelectRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0edf0",
  null
  
)

export default component.exports